import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { useTheme } from '../hooks/useTheme';
import { resolvePageContext } from '../utils/fanMemberUtils';
import { getFanMemberBrandTheme } from '../config/fanMembersConfig';

const SuccessPage = ({ fixedActivityType, fixedId, fixedFanSlug }) => {
  const { theme } = useTheme();
  const pageContext = resolvePageContext({ fixedFanSlug, fixedActivityType, fixedId });
  const { fanMember, isFanMemberRoute } = pageContext;
  const brand = getFanMemberBrandTheme(fanMember);

  return (
    <div className={`min-h-screen flex items-center justify-center p-4 ${isFanMemberRoute ? brand.pageBg : 'bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50'}`}>
      <div className={`max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center border transition-colors duration-300 ${isFanMemberRoute ? brand.cardBorder : 'border-blue-200'}`}>
        <div className="flex justify-center mb-6">
          <div className={`w-16 h-16 ${isFanMemberRoute ? brand.iconBg : 'bg-gradient-to-br from-blue-500 to-purple-600'} rounded-full flex items-center justify-center`}>
            <FaCheckCircle className="text-white text-3xl" />
          </div>
        </div>
        <h1 className={`text-2xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
          Registration Successful!
        </h1>
        <p className={`mb-8 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
          Thank you for registering. Your registration has been successfully processed. You will be redirected to the next page in 2 seconds.
        </p>
      </div>
    </div>
  );
};

export default SuccessPage;
